import React from "react";

type IconProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
};

const VideoIcon: React.FC<IconProps> = ({ size = 20, fill = "currentColor", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={(size * 16) / 20}
      viewBox="0 0 20 16"
      fill="none"
      {...props}>
      <path
        d="M14.2041 0.0107398C15.2128 0.11301 16 0.96435 16 2V6.5L18.293 4.20703C18.9229 3.57721 19.9999 4.02329 20 4.91406V11.0859C19.9999 11.9767 18.9229 12.4228 18.293 11.793L16 9.5V14C16 15.1046 15.1046 16 14 16H2C0.89543 16 0 15.1046 0 14V2C0 0.89543 0.89543 0 2 0H14L14.2041 0.0107398ZM2 14H14V2H2V14Z"
        fill={fill}
      />
    </svg>
  );
};

export default VideoIcon;
